import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTag } from '../features/tag/hook'
import CreatableSelect from 'react-select/creatable';
import { TagItems } from './tag-items';
import { useInternationalization } from '../features/i18n';

//eslint-disable-next-line
const backup = [
  {
    value: 1,
    label: 'Perdamaian',
  },
  {
    value: 2,
    label: 'Islam',
  },
  {
    value: 3,
    label: 'Peradaban Agama',
  },
  {
    value: 4,
    label: 'Tags A',
  },
  {
    value: 5,
    label: 'Tags B',
  },
]

const TagAdder = ({ data, onChange, noPreview }) => {
  const { tagOptions } = useTag()
  const [selectValue, setSelectValue] = useState(null)
  const [selectOptions, setSelectOptions] = useState(tagOptions)
  const { translate } = useInternationalization()

  const addItem = (value, { action }) => {
    if (action === 'select-option' || action === 'create-option') {
      const newData = [
        ...data,
        value
      ]

      onChange(newData)
      setSelectValue(null)
    }
  }

  const removeItem = (e) => {
    console.log(e)
    if(e){
      const { value } = e
      const newData = data.filter((item) => {
        return item.value !== value
      })
      onChange(newData)
      setSelectValue(null)
    }
  }

  // When data updated, disabled the selected data inside select options
  useEffect(() => {
    if(data){
      const selectedIds = data.map(v => v.value)
      const updatedSelectOptions = selectOptions.map((option) => {
        return {
          ...option,
          isDisabled: selectedIds.includes(option.value)
        }
      })
      setSelectOptions(updatedSelectOptions)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    setSelectOptions(tagOptions)
  }, [tagOptions])

  return (
    <div>
      {
        !noPreview &&
        <TagItems
          data={data}
          onRemove={removeItem}
        />
      }

      <CreatableSelect
        className="text-sm"
        options={selectOptions}
        value={selectValue}
        placeholder={`${translate('SEARCH', 'search')} tag`}
        onChange={addItem}
      />
    </div>
  )
}

TagAdder.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func
}

TagAdder.defaultProps = {
  data: [],
  onChange: () => {}
}

export { TagAdder }
